"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _tool = require("@entrylabs/tool");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = (0, _get2["default"])((0, _getPrototypeOf2["default"])(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
Entry.FieldMusicScale = /*#__PURE__*/function (_Entry$Field) {
  function FieldMusicScale(content, blockView, index) {
    var _this;
    (0, _classCallCheck2["default"])(this, FieldMusicScale);
    _this = _callSuper(this, FieldMusicScale, [content, blockView, index]);
    _this._block = blockView.block;
    _this._blockView = blockView;
    _this.box = new Entry.BoxModel();
    _this.svgGroup = null;
    _this._contents = content;
    _this._noArrow = content.noArrow;
    var bgColor = content.bgColor,
      textColor = content.textColor;
    var arrowColor = content.arrowColor;
    var _this$_block = _this._block,
      deletable = _this$_block.deletable,
      emphasized = _this$_block.emphasized;
    if (deletable === Entry.Block.DELETABLE_FALSE_LIGHTEN || emphasized) {
      arrowColor = blockView._fillColor;
    }
    _this._arrowColor = arrowColor;
    _this._textColor = textColor || '#FFFFFF';
    _this._bgColor = bgColor;
    _this._index = index;
    _this.setValue(_this.getValue() || 'C1');
    _this._CONTENT_HEIGHT = _this.getContentHeight(content.dropdownHeight);
    _this._font_size = _this.getFontSize(content.fontSize);
    _this._ROUND = content.roundValue || 2;
    _this.renderStart();
    return _this;
  }
  (0, _inherits2["default"])(FieldMusicScale, _Entry$Field);
  return (0, _createClass2["default"])(FieldMusicScale, [{
    key: "renderStart",
    value: function renderStart() {
      var blockView = this._blockView;
      var that = this;
      var CONTENT_HEIGHT = this._CONTENT_HEIGHT;
      var arrowInfo = this.getArrow();
      if (!this.svgGroup) {
        this.svgGroup = blockView.contentSvgGroup.elem('g', {
          "class": 'entry-field-music-scale'
        });
      }
      if (!this._header) {
        var x, y, WIDTH, HEIGHT;
        HEIGHT = this._CONTENT_HEIGHT;
        WIDTH = this._CONTENT_WIDTH + 10;
        var position = this._position;
        if (position) {
          x = position.x || 0;
          y = position.y || 0;
        } else {
          x = 0;
          y = -HEIGHT / 2;
        }
        this._header = this.svgGroup.elem('rect', {
          x: x,
          y: y,
          width: 35,
          //WIDTH,
          height: 20,
          //HEIGHT,

          rx: 2,
          ry: 2,
          fill: '#008380'
        });
      }
      if (!this.textElement) {
        this.textElement = this.svgGroup.elem('text', {
          x: 5,
          style: 'white-space: pre;',
          fill: this._textColor,
          'font-size': "".concat(+that._font_size, "px"),
          'font-weight': 'bold',
          'font-family': EntryStatic.fontFamily || 'NanumGothic'
        });
      }
      if (!this._noArrow && !this._arrow) {
        this._arrow = this.svgGroup.elem('path', {
          d: "M 5.79 0.818\n                L 3.339 3.8\n                a 0.5 0.5 0 0 1 -0.772 0\n                L 0.114 0.818\n                A 0.5 0.5 0 0 1 0.5 0\n                h 4.904\n                a 0.5 0.5 0 0 1 0.387 0.818\n                z\n                ",
          fill: arrowInfo.color,
          stroke: arrowInfo.color
        });
      }
      this._updateTextRender();
    }
  }, {
    key: "resize",
    value: function resize() {
      var _this$_block$view;
      var X_PADDING = 20;
      var X_PADDING_SUBT = 10;
      var board = this._blockView.getBoard() || {};
      var _ref = board || {},
        _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 1 : _ref$scale;
      var width = this.textElement.getBoundingClientRect().width / scale + X_PADDING;
      if (!this._noArrow) {
        var arrowInfo = this.getArrow();
        this._arrow.attr({
          transform: "translate(".concat(width - arrowInfo.width - 5, ",").concat(-arrowInfo.height / 2, ")")
        });
      } else {
        width -= X_PADDING_SUBT;
      }
      this._header.attr({
        width: width
      });
      this.box.set({
        width: width
      });
      (_this$_block$view = this._block.view) === null || _this$_block$view === void 0 || _this$_block$view.dAlignContent();
    }
  }, {
    key: "_attachDisposeEvent",
    value: function _attachDisposeEvent(func) {
      var _this2 = this;
      var action = func;
      if (!action) {
        action = function action(skipCommand) {
          _this2.destroyOption(skipCommand);
          _this2._selectBlockView();
        };
      }
      this.disposeEvent = Entry.disposeEvent.attach(this, action);
    }
  }, {
    key: "getArrow",
    value: function getArrow() {
      return {
        color: this._arrowColor || '#ffffff',
        points: '0,0 6.4,0 3.2,4.2',
        height: 4.2,
        width: 6.4
      };
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(neighborFields) {
      var _this3 = this;
      this.optionGroup = Entry.Dom('div', {
        "class": 'entry-widget-music-scale',
        parent: $('body')
      });
      var currentValue = this.getValue();
      var scale = currentValue.substr(0, currentValue.length - 1);
      var octave = currentValue[currentValue.length - 1];
      this.optionWidget = new _tool.MusicScale({
        type: 'musicScaleWidget',
        data: {
          eventTypes: ['mousedown', 'touchstart', 'wheel'],
          positionDom: this.svgGroup,
          onOutsideClick: function onOutsideClick() {
            _this3.destroyOption();
          },
          scale: scale || 'C',
          octave: octave || 1
        },
        container: this.optionGroup[0]
      }).on('click', function (eventName, value) {
        var prevValue = String(_this3.getValue());
        switch (eventName) {
          case 'changedValue':
            if (prevValue === '0' && _.includes(['0', '.'], value) === false) {
              prevValue = '';
            }
            _this3.applyValue(value);
            break;
        }
      });
    }
  }, {
    key: "getContentHeight",
    value: function getContentHeight(height) {
      return height || this._blockView.getSkeleton().dropdownHeight || 20;
    }
  }, {
    key: "applyValue",
    value: function applyValue(value) {
      if (this.value != value) {
        this.setValue(value);
      }
      this._setTextValue();
      this.resize();
    }
  }, {
    key: "destroyOption",
    value: function destroyOption(skipCommand, forceCommand) {
      if (this.optionWidget) {
        this.optionWidget.isShow && this.optionWidget.hide();
        this.optionWidget.remove();
        delete this.optionWidget;
      }
      if (this.optionGroup) {
        this.optionGroup.remove();
      }
      _superPropGet(FieldMusicScale, "destroyOption", this, 3)([]);
    }
  }, {
    key: "getTextWidth",
    value: function getTextWidth() {
      return Math.max(this.getTextBBox().width, 7);
    }
  }, {
    key: "_updateTextRender",
    value: function _updateTextRender() {
      var X_PADDING = 20;
      var X_PADDING_SUBT = 10;
      var CONTENT_HEIGHT = this._CONTENT_HEIGHT;
      var arrowInfo = this.getArrow();
      this._setTextValue();
      var bBox = this.getTextBBox();
      this.textElement.attr({
        y: bBox.height * 0.27
      });
      var width = bBox.width + X_PADDING;
      if (this._noArrow) {
        width -= X_PADDING_SUBT;
      }
      this._header.attr({
        width: width
      });
      if (!this._noArrow) {
        this._arrow.attr({
          transform: "translate(".concat(width - arrowInfo.width - 5, ",").concat(-arrowInfo.height / 2, ")")
        });
      }
      this._bindRenderOptions();
      this.box.set({
        x: 0,
        y: 0,
        width: width,
        height: CONTENT_HEIGHT
      });
    }
  }, {
    key: "_setTextValue",
    value: function _setTextValue() {
      var textValue = this.getValue();
      var newValue = this._convert(textValue, this.getValue());
      if (this.getTextValue() !== newValue) {
        var scale = newValue.substr(0, newValue.length - 1);
        var octave = newValue[newValue.length - 1];
        this.textElement.textContent = "".concat(octave, " ").concat(Lang.Blocks.octave, " ").concat(scale);
      }
    }
  }, {
    key: "getTextValue",
    value: function getTextValue() {
      return this.textElement.textContent;
    }
  }]);
}(Entry.Field);